import { createAction } from '@reduxjs/toolkit';
import { actionTypes } from 'common/state/modals/constants';

export const showRecommendedFieldsModal = createAction<boolean>(
  actionTypes.SHOW_RECOMMENDED_FIELDS_MODAL,
);
export const setIsSubmittedRecommendedFieldsModal = createAction<boolean>(
  actionTypes.SET_IS_SUBMITTED_RECOMMENDED_FIELDS_MODAL,
);
